export default "__VITE_ASSET__BYBEx_cb__"